import * as React from 'react'
import { connect } from 'react-redux'

import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap'

import { RootState } from 'src/store/rootReducer'
import { Location } from 'src/lib/interfaces/Location.interface'
import { User, hasPermission } from 'src/lib/interfaces/User.interface'
import { AccidentFilterParameters } from 'src/lib/interfaces/AccidentFilterParameters.interface'

import * as appSelectors from 'src/store/app/selectors'

const map = require('lodash/map')

const moment = require('moment')

export interface AccidentDefaultFilterDropdownProps {
  user: User
  className?: string
  locations?: Location[]
  onSelectFilters: (filters: AccidentFilterParameters) => void
}

const FILTERS = {
  pendingApproval: { managerApproval: ['PENDING'] }
}

const today = moment().format('YYYY-MM-DD')
const thisYear = moment().startOf('year').format('YYYY-MM-DD')

const INITIAL_FILTERS: AccidentFilterParameters = {
  lossDateTo: today,
  sortBy: undefined,
  location: undefined,
  sortOrder: undefined,
  lossDateFrom: thisYear,
  accidentTypes: undefined,
  accidentStatus: undefined,
  managerApproval: undefined,
  locationPosition: undefined
}

class AccidentDefaultFilterDropdown extends React.PureComponent<AccidentDefaultFilterDropdownProps> {
  handleSelectOption(option) {
    const { user, locations, onSelectFilters } = this.props

    const filters = {
      ...INITIAL_FILTERS,
      ...FILTERS[option]
    }

    if (!filters.location && locations && !hasPermission(user, 'ROLE_ACCIDENT_ADMIN')) {
      filters.location = map(locations, location => location.id)
    }

    if (filters) {
      onSelectFilters(filters)
    }
  }

  render() {
    const { className } = this.props

    return (
      <UncontrolledButtonDropdown className={className}>
        <DropdownToggle caret size="sm" color="info" className="ggbutton">Default filters</DropdownToggle>
        <DropdownMenu>
          <DropdownItem onClick={() => this.handleSelectOption('pendingApproval')}>Pending approval</DropdownItem>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
  locations: appSelectors.getLocations(state)
})

export default connect(mapStateToProps)(AccidentDefaultFilterDropdown)



// WEBPACK FOOTER //
// ./src/routes/accidents/components/AccidentDefaultFilterDropdown.component.tsx